import { isDigitCharCode } from './isDigitCharCode'
import { ExtractedSeparators } from './types/extractedSeparators'
import { SeparatorCounts } from './types/separatorCounts'
import { SeparatorPositions } from './types/separatorPositions'

/**
 * Extracts non-digit characters (potential separators) from the string.
 */
export const extractSeparators = (input: string): ExtractedSeparators => {
  const separatorCounts: SeparatorCounts = {}
  const separatorPositions: SeparatorPositions = {}

  for (const [index, character] of Array.from(input).entries()) {
    const charCode = character.charCodeAt(0)

    if (!isDigitCharCode(charCode)) {
      if (!separatorCounts[character]) {
        separatorCounts[character] = 1
        separatorPositions[character] = [index]
      } else {
        separatorCounts[character]++
        separatorPositions[character].push(index)
      }
    }
  }

  return { separatorCounts, separatorPositions }
}
